const SESSION_RATING = {
  Bad: 0,
  Good: 1,
};

export default SESSION_RATING;
